import { ApplicationConfig, enableProdMode, ErrorHandler, importProvidersFrom, inject, provideZoneChangeDetection } from '@angular/core';
import { RouterModule } from '@angular/router';
import { Environment } from '@env/environment';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi, withJsonpSupport } from '@angular/common/http';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { PopupService } from '@progress/kendo-angular-popup';
import { IconsService } from '@progress/kendo-angular-icons';
import { ResizeBatchService } from '@progress/kendo-angular-common';
import { BrowserModule } from '@angular/platform-browser';
import { routes } from './app.routes';
import { AuthInterceptor } from './core/services/auth-interceptor';
import { DateHttpInterceptor } from './core/services/date-http-interceptor';
import { provideHttpClientTesting } from '@angular/common/http/testing';
import { NotificationService } from '@progress/kendo-angular-notification';
import { AppErrorHandler } from './core/services/app-error-handler';

if (Environment.production) {
	enableProdMode();
}

export const appConfig: ApplicationConfig = {
	providers: [
		{ provide: PopupService },
		{ provide: IconsService },
		{ provide: ResizeBatchService },
		{ provide: NotificationService },
		Environment,
		{ provide: ErrorHandler, useClass: AppErrorHandler },
		provideZoneChangeDetection({ eventCoalescing: true }),
		importProvidersFrom(RouterModule.forRoot(routes)),
		provideHttpClient(withJsonpSupport(), withInterceptorsFromDi()),
		{
			provide: HTTP_INTERCEPTORS,
			useClass: AuthInterceptor,
			multi: true,
		},

		{ provide: HTTP_INTERCEPTORS, useClass: DateHttpInterceptor, multi: true },
		importProvidersFrom([BrowserModule, BrowserAnimationsModule]),
	],
};
